import useSWR from "swr"

import {fetcher} from "../../../utilities/general.jsx"

export const fyLabel = (year) => (year ? `FY${String(year).slice(-2)}` : "")

export const metricBadgeProps = (current, previous, isPositiveGood) => {
    if (current == null || !previous) return null
    const percentage = Math.round(((current - previous) / Math.abs(previous)) * 100)
    if (percentage === 0) return {variant: "secondary", text: "No Change"}
    if (percentage < 0) return {variant: isPositiveGood ? "danger" : "success", text: `${percentage}%`}
    return {variant: isPositiveGood ? "success" : "danger", text: `+${percentage}%`}
}

export const useMetricsQuery = (endpoint, filters, fallbackData, {withFiscalYear = true} = {}) => {
    const {organization_id, facility_ids, unit_ids, experience_level_ids, fiscal_year} = filters

    const ready = organization_id && (!withFiscalYear || fiscal_year)

    const body = {
        organization_id,
        ...(withFiscalYear && {fiscal_year}),
        ...(facility_ids?.length && {facility_ids}),
        ...(unit_ids?.length && {unit_ids}),
        ...(experience_level_ids?.length && {experience_level_ids}),
    }

    return useSWR(ready ? [`/metrics/${endpoint}`, body] : null, ([url, body]) => fetcher(url, body), {fallbackData})
}
